import { split, length } from "ramda";
import { prod } from "application/constants/app-constants";

export default function getSiteId() {
  let value = "bafe64f1-fff9-474d-8595-0e47fa5db8ee";
  if (prod) {
    const restNumber = 4;
    const pathnames = split("/", window.location.pathname);
    value = pathnames[length(pathnames) - restNumber];
  }
  return value;
}
